import { render, staticRenderFns } from "./FlexLoader.vue?vue&type=template&id=6328c08b&scoped=true&"
import script from "./FlexLoader.vue?vue&type=script&lang=js&"
export * from "./FlexLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6328c08b",
  null
  
)

export default component.exports